export const patentByYearChart = {
    xAxis: '年',
    yAxis: '特許出願数',
    legend: '企業名',

    csvColumn1: '企業名',
    csvColumn2: '年',
    csvColumn3: '特許カウント'
}
